import { isKycKybBypassEnabled } from '../config/featureFlags';

type PublisherType = 'Organization' | 'Individual' | null | undefined;

const getPublisherVerificationActionMessage = (
  publisherType?: PublisherType,
) => {
  const verificationType = publisherType === 'Individual' ? 'KYC' : 'KYB';
  return `Complete ${verificationType} verification for this publisher account to add dApps or publish new versions.`;
};

const getPublisherVerificationNewVersionMessage = (
  publisherType?: PublisherType,
) => {
  const verificationType = publisherType === 'Individual' ? 'KYC' : 'KYB';
  return `Complete ${verificationType} verification for this publisher account before creating a new version.`;
};

const isPublisherVerificationApproved = (
  status?: string | null,
  kycKybBypassEnabled = false,
  bypass = isKycKybBypassEnabled(),
) => kycKybBypassEnabled || bypass || status === 'Approved';

export const getPublisherVerificationGate = ({
  status,
  publisherType,
  kycKybBypassEnabled,
}: {
  status?: string | null;
  publisherType?: PublisherType;
  kycKybBypassEnabled?: boolean;
}) => ({
  isApproved: isPublisherVerificationApproved(status, kycKybBypassEnabled),
  actionMessage: getPublisherVerificationActionMessage(publisherType),
  newVersionMessage: getPublisherVerificationNewVersionMessage(publisherType),
});
